<template>
  <div id="abousection">
    <Why />
    <Recognition />
  </div>
</template>
<script>
//-import About from "./About.vue";
//import Regtech from "./Regtech.vue";
import Recognition from './Recognition.vue';
import Why from './Why.vue';
export default {
  name: 'abousection',
  components: {
    //-About,
    //-Regtech,
    Recognition,
    Why,
  },
};
</script>
